import { render, staticRenderFns } from "./SiteRoleListTop.vue?vue&type=template&id=1c2df85a&"
import script from "./SiteRoleListTop.vue?vue&type=script&lang=js&"
export * from "./SiteRoleListTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports